<template>
	<div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
			<list-btn
      ref="actionbtn" 
      :uploadUrl="uploadUrl"
      :downloadUrl="downloadUrl"
      @uploadExcel="uploadExcel"
      @uploadBtn="uploadBtn"
			:listArr="listArr"
			:sdata="sdata"
			@detail="detail"
			@edit="edit"
			@add="add"
			@del="del"
			@restore="restore"
			isAdd
			isEdit
			isDelStatus
      isExcel
			></list-btn>

      <tab-list
      :tabList="listArr"
      :total="total"
      :pages="pages"
      :fromData="fromData"
      :columns="tabColumns"
      tabName="base-supplier"
      @currentChange="currentChange"
      @changePages="changePages"
      @selectSdata="selectSdata"
      @dbClick="dbClick">
      </tab-list>


      <!-- 详情 -->
      <el-dialog title="供应商详情"
      :visible.sync="dialogFormVisible"
      customClass="dialog_detail_style"
      v-dialogDrag @closed="closedDialog" >
        <detail :sdata="sdata" class="contnet_box"></detail>
      </el-dialog>

	</div>
</template>

<script>
import {excelUpload,excelDownload} from 'api/excel.js'
import {suplierApi} from 'api/base.js'

import listBtn from 'components/btn/listBtn.vue';
import tabList from 'components/table/list.vue';
import searchBox from './components/list/search.vue';
import detail from './detail.vue';

export default{
	components:{searchBox,listBtn,tabList,detail},
	data() {
		return {
      dialogFormVisible:false,
      isComponentChild:false,
      isDelList:false,//是否显示已删除的
			sdata:{},
      listArr:[],//列表
      downloadUrl:excelDownload.supplier,
      uploadUrl:excelUpload.supplier,
      tabColumns:[
        {field: 'supplierCode', title: '供应商编码',need:true, width:120,"sortable":true},
        {field: 'supplierName', title: '供应商描述',need:true},
        {field: 'contact', title: '联系人'},
        {field: 'telephone', title: '联系电话'},
        {field: 'address', title: '地址',
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          let address = "";
          if(rowData.area) address = rowData.area;
          if(rowData.streetOrAddress) address = address + rowData.streetOrAddress;
          return address;
        }},
        {field: 'vatRegiNum', title: '增值税登记号'},
        {field: 'maintainStatus', title: '状态',
        formatter: function (rowData,rowIndex,pagingIndex,field) {
          return rowData.maintainStatus === 'X' ? "已删除" : "正常";
        }
        }
      ],//表头字段
			maintainStatus:[
				{
					text:'正常',
					value:''
				},
				{
					text:"已删除",
					value:"X"
				}
			],
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:20,//每页显示的数量,
				searchCriteria:{//查询的附加条件
				}
			}
		}
	},
	created(){
		this.getList();
	},
  updated:function(){

  },
	methods:{
    //双击
    dbClick(data){
      this.sdata = data;
      this.detail();
    },
		showErrorMsg(txt){
			this.$message.error(txt);
		},
    //选中数据
    selectSdata(data){
      this.sdata = data;
      // console.log(this.sdata)
    },
    //当前页码改变
    currentChange(currentPage){
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
		//获取列表
		async getList(){
			let res = await this.$post(suplierApi.list,this.fromData);
			const {data,msg,status,msgCode} = res;
      this.isListLoading = false;
      if(status){
        this.listArr = data.list;
        this.pages = data.pages;
        this.total = data.total;
        this.listArr.map((item, index) => {
          if(item.maintainStatus === 'X'){
            item.isDel = true;
          }else{
            item.isDel = false;
          }
          return item;
        });
        console.log(this.listArr,9999);
      }
      this.isComponentChild = true;
		},

		handleSelectChange(item,key){
			if(item.isChecked){
				item.isChecked = false;
				this.sdata = {};
			}else{
				this.sdata = item;
				this.sdata.index = key;
				item.isChecked = true;
				this.listArr.forEach((items)=>{
					if(items.supplierId != item.supplierId){
						items.isChecked = false;
					}
				});
				if(item.maintainStatus === 'X'){
					this.sdata.isDel = true;
				}else{
					this.sdata.isDel = false;
				}
			}
		},

    //搜索
    subSearch(){
      this.getList();
    },
    //详情
    async detail(){
      if(!this.sdata.supplierId){
      	this.$message.error('请选择要查看的');
      	return;
      }
      this.dialogFormVisible = true;
     /* let res = await this.$get(suplierApi.find,{"supplierId":this.sdata.supplierId});
      if(res.status) this.detailSdata = res.data; */
    },
    //关闭弹出层
    closedDialog(){
      this.dialogFormVisible = false;
    },
		//新增
		add(){
			this.$router.push({name: 'base-supplier-add'});
		},
		//编辑
		edit(){
			if(!this.sdata.supplierId){
				this.$message.error('请选择要编辑的');
				return;
      }
      if(this.sdata.maintainStatus === 'X'){
        this.$message.error('该条记录已删除，不允许编辑！');
				return;
      }
			this.$router.push({name: 'base-supplier-edit', params: {id:this.sdata.supplierId}});
		},
    
    //删除
    del(){
      let vm = this;
      if(!this.sdata.supplierId){
        this.$message.error('请选择需要删除的记录');
        return;
      }
      this.$confirm('确定删除这条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeDataStatus(suplierApi.del,"删除成功！","X");
      }).catch(() => {});
    },
    //恢复删除
    restore(){
      let vm = this;
      if(!this.sdata.supplierId){
        this.$message.error('请选择需要恢复的记录');
        return;
      }
      this.$confirm('恢复此记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          this.changeDataStatus(suplierApi.restore,"修改成功！","");
      });
    },
    /**
     * [ 改变物料状态 ]
     * @param {Object} api 调用的接口
     * @param {Object} message 操作成功后，提示的消息
     * @param {Object} status  操作成功后，状态
     */
    async changeDataStatus(api,message,status){
      this.$store.state.loadingTxt = "处理中...";
      this.$store.state.isLoading = true;
      let res = await this.$get(api,{supplierId:this.sdata.supplierId});
      this.$store.state.isLoading = false;
      if(res.status){
        this.$message.success("供应商"+this.sdata.supplierCode+message);
        this.$set(this.sdata,'maintainStatus',status);
      }else{
        this.$message.error(res.msg);
        this.sdata.isDel = false;
      }
    },
    
    uploadBtn(){
      this.$refs.actionbtn.uploadDialog = true;
      console.log(1111);
    },
    //上传excel
    uploadExcel(res){
      console.log(11111);
      if(!res.data) return;
      if(res.data){
        console.log(res.data,88888); return;
      }
      let list = res.data.rightData;
      list.forEach((item)=>{
        let resIndex = this.selectedList.findIndex(v=>v.materialCode === item.materialCode);
        if(resIndex != -1){//存在相加
          let quantity = item.quantity +this.selectedList[resIndex].quantity;
          this.$set(this.selectedList[resIndex],'quantity',quantity);
        }else{
          let objData = {
            basicUnitCode: item.basicUnitCode,
            basicUnitDesc: item.basicUnitDesc,
            basicUnitId: item.basicUnitId,
            materialCode: item.materialCode,
            materialDesc: item.materialDesc,
            materialId: item.materialId,
            standardCurrAmount: item.purchasePrice,//价格
            quantity: item.quantity,//数量
            materialGroupDesc: item.materialGroupDesc,//物料组描述
            materialGroupId:item.materialGroupId,//物料组IE
            materialTypeId: item.materialTypeId,//物料类型
            materialTypeName: item.materialTypeName,
            "factoryCode":this.fromData.factoryCode,//工厂
            "factoryDesc":this.fromData.factoryDesc,
            "factoryId":this.fromData.factoryId,
            "inventoryCode":this.fromData.inventoryCode,//库存地
            "inventoryDesc":this.fromData.inventoryDes,
            "inventoryId":this.fromData.inventoryId,
            "supplierCode":this.noFromData.supplierCode,//供应商
            "supplierDesc":this.noFromData.supplierName,
            "supplierId":this.noFromData.supplierId,
          };
          this.selectedList.push(objData);
        }
      });

      //错误的
      let failData = res.data.failData;
      if(failData.length){
        this.isExcelError = true;
        this.excelErrorList = failData;
      }
    }

	}
}
</script>

<style>
</style>
